import { lazyForPaint } from 'react-loosely-lazy';
export const LazyCustomerPrivacyAndSecurityTab = lazyForPaint(() => import(/* webpackPrefetch: true, webpackChunkName: "chunk-privacy-security-tab" */'@atlassian/mpac-privacy-security').then(module => {
  return module.CustomerPrivacyAndSecurityTab;
}));
export const LazyPrivacySecurityDetailsNotAvailableBannerV2 = lazyForPaint(() => import(/* webpackPrefetch: true, webpackChunkName: "chunk-privacy-security-banner" */'@atlassian/mpac-privacy-security').then(module => {
  return module.PrivacySecurityDetailsNotAvailableBannerV2;
}));